module.exports = __webpack_public_path__ + "c43ca0d6.svg";